import React, {useEffect} from 'react';

function Banner() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<>
        <section className="home-banner-section overflow-hidden">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-md-left text-center">
                        <div className="home-banner-text-setting wow slideInLeft" data-wow-duration="2s">
                            <div className="home-banner-text">
                                <h1 className="mb-lg-4 mb-3 text-white poppins-bold">CALL CENTER SERVICES FOR​
                                    THE RESTAURANT INDUSTRY</h1>
                            </div>
                            {/*<div className="home-banner-button list-inline">*/}
                            {/*    <div className="free-outer list-inline-item">*/}
                            {/*        <a href="login.html" className="free hover-effect">Try for Free</a>*/}
                            {/*    </div>*/}
                            {/*    <div className="list-inline-item">*/}
                            {/*        <a className="play-icon hover-effect" href="#video-section"><i*/}
                            {/*            className="fas fa-play"></i></a>*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12 text-center">

                    </div>
                </div>
            </div>
        </section>
    </>);
}

export default Banner;